export default "__VITE_ASSET__BkVLF3gn__"